/**
 * Интерактивный звёздный ввод оценки (1..5) — дизайн guest v7 §18 «.stars .s».
 *
 * Доступность: радиогруппа из 5 кнопок; клавиатура (стрелки/цифры) работает
 * через нативный фокус кнопок. Полностью русский (aria-label), мобайл-friendly
 * (крупная зона нажатия). Контролируемый: value/onChange.
 */
import type { JSX } from 'react';

export interface StarInputProps {
  /** Текущая оценка 0..5 (0 = не выбрано). */
  value: number;
  /** Колбэк выбора оценки. */
  onChange: (rating: number) => void;
  /** Подпись группы для скринридера. */
  ariaLabel?: string;
}

const STARS = [1, 2, 3, 4, 5] as const;

export function StarInput({ value, onChange, ariaLabel = 'Оценка' }: StarInputProps): JSX.Element {
  return (
    <div className="rev-stars-input" role="radiogroup" aria-label={ariaLabel} data-testid="star-input">
      {STARS.map((n) => {
        const active = n <= value;
        return (
          <button
            key={n}
            type="button"
            role="radio"
            aria-checked={value === n}
            aria-label={`${n} из 5`}
            className={`rev-star-btn${active ? ' is-on' : ''}`}
            onClick={() => onChange(n)}
            data-testid={`star-${n}`}
          >
            ★
          </button>
        );
      })}
    </div>
  );
}

export default StarInput;
